import styled from 'styled-components'
import { grayLight, media, transition, white } from 'utils/style-utils'

export const BulletsBox = styled.div`
  width: 100%;
  height: 1rem;

  position: absolute;
  z-index: 5;
  bottom: 0.5rem;

  display: flex;
  gap: 0.5rem;
  justify-content: center;

  ${media.sm`
    bottom: 4.5rem;
  `}
`

export const Bullet = styled.div<{ selected: boolean }>`
  width: 2rem;
  height: 100%;

  :after {
    ${transition('all', 0.6)};

    display: block;
    content: '';
    width: 100%;
    height: 0.125rem;
    margin-top: 0.45rem;
    background-color: ${({ selected }) => (selected ? white : grayLight)};
  }

  cursor: pointer;

  :hover {
    :after {
      background-color: ${white};
      filter: drop-shadow(0 0 4px ${white}) drop-shadow(0 0 8px ${white});
    }
  }
`
